import { Avatar, AvatarFallback, AvatarImage } from '../ui/avatar'
import { stringToColour } from '../../../app/utils/changeBackgroundColorOfInitials'
import { getNameInitial } from '../../../app/utils/getNameInitial'
import { CSSProperties } from 'react'

export const BasicAvatar = ({
  profileImageUrl,
  name,
  style,
}: {
  profileImageUrl: string | undefined
  name: string | undefined
  style?: CSSProperties
}) => {
  return (
    <Avatar>
      <AvatarImage
        src={
          profileImageUrl
            ? `${import.meta.env.VITE_CDN_URL}${profileImageUrl}`
            : ''
        }
      />
      <AvatarFallback
        style={{
          backgroundColor: `${stringToColour(name ?? '')}`,
          ...style
        }}
      >
        {getNameInitial(name ?? '')}
      </AvatarFallback>
    </Avatar>
  )
}
